import ScoreFootball from "./ScoreFootball";
export default ScoreFootball;
